// generated from 127 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const hasLocationFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("has_location_filter"),
  comparison_key: z.literal("1"),
  display_name: z.string(),
  // undefined: 62 (48.82%), defined 65 (51.18%)
  // true 64 (98.46%), false 1 (1.54%)
  raw_value: z.boolean().optional(),
  // true 116 (91.34%), false 11 (8.66%)
  value: z.boolean(),
  varies_by_app_group: z.literal(false),
});
